// Generated by Framer (1bcc82d)
import { jsx as _jsx } from "react/jsx-runtime";
import { addFonts, addPropertyControls, ControlType, cx, getFontsFromSharedStyle, Link, RichText, useComponentViewport, useLocaleInfo, useVariantState, withCSS } from "framer";
import { LayoutGroup, motion, MotionConfigContext } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
import * as sharedStyle from "https://framerusercontent.com/modules/3J57oeBJoeysZ4E3GIZp/eiDjtd60uU2CAFpABIF5/doUCpi5z9.js";
const enabledGestures = {
  hfxk78S08: {
    pressed: true
  },
  oF0UX6Piw: {
    hover: true
  }
};
const cycleOrder = ["oF0UX6Piw", "hfxk78S08"];
const serializationHash = "framer-lXt31";
const variantClassNames = {
  hfxk78S08: "framer-v-1366p0n",
  oF0UX6Piw: "framer-v-14cvafi"
};
function addPropertyOverrides(overrides, ...variants) {
  const nextOverrides = {};
  variants?.forEach(variant => variant && Object.assign(nextOverrides, overrides[variant]));
  return nextOverrides;
}
const transition1 = {
  bounce: 0.2,
  delay: 0,
  duration: 0.4,
  type: "spring"
};
const Transition = ({
  value,
  children
}) => {
  const config = React.useContext(MotionConfigContext);
  const transition = value ?? config.transition;
  const contextValue = React.useMemo(() => ({
    ...config,
    transition
  }), [JSON.stringify(transition)]);
  return /*#__PURE__*/_jsx(MotionConfigContext.Provider, {
    value: contextValue,
    children: children
  });
};
const Variants = motion.create(React.Fragment);
const humanReadableVariantMap = {
  "Variant 1": "oF0UX6Piw",
  "Variant 2": "hfxk78S08"
};
const getProps = ({
  height,
  id,
  width,
  ...props
}) => {
  return {
    ...props,
    variant: humanReadableVariantMap[props.variant] ?? props.variant ?? "oF0UX6Piw"
  };
};
const createLayoutDependency = (props, variants) => {
  if (props.layoutDependency) return variants.join("-") + props.layoutDependency;
  return variants.join("-");
};
const Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
  const fallbackRef = useRef(null);
  const refBinding = ref ?? fallbackRef;
  const defaultLayoutId = React.useId();
  const {
    activeLocale,
    setLocale
  } = useLocaleInfo();
  const componentViewport = useComponentViewport();
  const {
    style,
    className,
    layoutId,
    variant,
    ...restProps
  } = getProps(props);
  const {
    baseVariant,
    classNames,
    clearLoadingGesture,
    gestureHandlers,
    gestureVariant,
    isLoading,
    setGestureState,
    setVariant,
    variants
  } = useVariantState({
    cycleOrder,
    defaultVariant: "oF0UX6Piw",
    enabledGestures,
    ref: refBinding,
    variant,
    variantClassNames
  });
  const layoutDependency = createLayoutDependency(props, variants);
  const sharedStyleClassNames = [sharedStyle.className];
  const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
  return /*#__PURE__*/_jsx(LayoutGroup, {
    id: layoutId ?? defaultLayoutId,
    children: /*#__PURE__*/_jsx(Variants, {
      animate: variants,
      initial: false,
      children: /*#__PURE__*/_jsx(Transition, {
        value: transition1,
        children: /*#__PURE__*/_jsx(Link, {
          href: {
            hash: ":BvppAfnk5",
            webPageId: "augiA20Il"
          },
          motionChild: true,
          nodeId: "oF0UX6Piw",
          openInNewTab: false,
          scopeId: "yG10ruTg3",
          smoothScroll: true,
          children: /*#__PURE__*/_jsx(motion.a, {
            ...restProps,
            ...gestureHandlers,
            className: `${cx(scopingClassNames, "framer-14cvafi", className, classNames)} framer-behugj`,
            "data-border": true,
            "data-framer-name": "Variant 1",
            layoutDependency: layoutDependency,
            layoutId: "oF0UX6Piw",
            ref: refBinding,
            style: {
              "--border-bottom-width": "1px",
              "--border-color": "var(--token-0aa53fec-fefb-40a3-a229-e26994a82701, rgba(255, 255, 255, 0.3))",
              "--border-left-width": "1px",
              "--border-right-width": "1px",
              "--border-style": "solid",
              "--border-top-width": "1px",
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderBottomLeftRadius: 48,
              borderBottomRightRadius: 48,
              borderTopLeftRadius: 48,
              borderTopRightRadius: 48,
              ...style
            },
            variants: {
              "hfxk78S08-pressed": {
                backgroundColor: "rgba(255, 255, 255, 0.05)"
              },
              "oF0UX6Piw-hover": {
                backgroundColor: "rgba(255, 255, 255, 0.05)"
              }
            },
            ...addPropertyOverrides({
              "hfxk78S08-pressed": {
                "data-framer-name": undefined
              },
              "oF0UX6Piw-hover": {
                "data-framer-name": undefined
              },
              hfxk78S08: {
                "data-framer-name": "Variant 2"
              }
            }, baseVariant, gestureVariant),
            children: /*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  style: {
                    "--framer-text-color": "var(--extracted-r6o4lv, var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(255, 255, 255)))"
                  },
                  children: globalThis.__COLLABYN_COPY__?.["Contact Us"] ?? "Contact Us"
                })
              }),
              className: "framer-1fzwoe6",
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "PZZa4nmWa",
              style: {
                "--extracted-r6o4lv": "var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(255, 255, 255))",
                "--framer-link-text-color": "rgb(0, 153, 255)",
                "--framer-link-text-decoration": "underline"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            })
          })
        })
      })
    })
  });
});
const css = ["@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }", ".framer-lXt31.framer-behugj, .framer-lXt31 .framer-behugj { display: block; }", ".framer-lXt31.framer-14cvafi { align-content: center; align-items: center; cursor: pointer; display: flex; flex-direction: row; flex-wrap: nowrap; gap: 8px; height: 48px; justify-content: center; overflow: hidden; padding: 16px; position: relative; text-decoration: none; width: min-content; will-change: var(--framer-will-change-override, transform); }", ".framer-lXt31 .framer-1fzwoe6 { -webkit-user-select: none; flex: none; height: auto; position: relative; user-select: none; white-space: pre; width: auto; }", ...sharedStyle.css, '.framer-lXt31[data-border="true"]::after, .framer-lXt31 [data-border="true"]::after { content: ""; border-width: var(--border-top-width, 0) var(--border-right-width, 0) var(--border-bottom-width, 0) var(--border-left-width, 0); border-color: var(--border-color, none); border-style: var(--border-style, none); width: 100%; height: 100%; position: absolute; box-sizing: border-box; left: 0; top: 0; border-radius: inherit; pointer-events: none; }'];
/**
 * This is a generated Framer component.
 * @framerIntrinsicHeight 48
 * @framerIntrinsicWidth 127
 * @framerCanvasComponentVariantDetails {"propertyName":"variant","data":{"default":{"layout":["auto","fixed"]},"hfxk78S08":{"layout":["auto","fixed"]},"OlWzAxrOt":{"layout":["auto","fixed"]},"Kl9Ntlwwj":{"layout":["auto","fixed"]}}}
 * @framerImmutableVariables true
 * @framerDisplayContentsDiv false
 * @framerAutoSizeImages true
 * @framerComponentViewportWidth true
 * @framerColorSyntax true
 */
const FrameryG10ruTg3 = withCSS(Component, css, "framer-lXt31");
export default FrameryG10ruTg3;
FrameryG10ruTg3.displayName = "Nav Button";
FrameryG10ruTg3.defaultProps = {
  height: 48,
  width: 127
};
addPropertyControls(FrameryG10ruTg3, {
  variant: {
    options: ["oF0UX6Piw", "hfxk78S08"],
    optionTitles: ["Variant 1", "Variant 2"],
    title: "Variant",
    type: ControlType.Enum
  }
});
addFonts(FrameryG10ruTg3, [{
  explicitInter: true,
  fonts: [{
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    url: "/assets/ba02b29b109b-5vvr9Vy74if2I6bQbJvbw7SY1pQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    url: "/assets/d342a0351181-EOr0mi4hNtlgWNn9if640EZzXCo.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+1F00-1FFF",
    url: "/assets/29ec2a1bd449-Y9k9QrlZAqio88Klkmbd8VoMQc.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0370-03FF",
    url: "/assets/2666a469c59b-OYrD2tBIBPvoJXiIHnLoOXnY9M.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    url: "/assets/ca74d6701961-JeYwfuaPfZHQhEG8U5gtPDZ7WQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    url: "/assets/61418a355f78-vQyevYAyHtARFwPqUzQGpnDs.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB",
    url: "/assets/b055aed328b3-b6Y37FthZeALduNqHicBT6FutY.woff2",
    weight: "400"
  }]
}, ...getFontsFromSharedStyle(sharedStyle.fonts)], {
  supportsExplicitInterCodegen: true
});
export const __FramerMetadata__ = {
  exports: {
    Props: {
      type: "tsType",
      annotations: {
        framerContractVersion: "1"
      }
    },
    default: {
      type: "reactComponent",
      name: "FrameryG10ruTg3",
      slots: [],
      annotations: {
        framerCanvasComponentVariantDetails: '{"propertyName":"variant","data":{"default":{"layout":["auto","fixed"]},"hfxk78S08":{"layout":["auto","fixed"]},"OlWzAxrOt":{"layout":["auto","fixed"]},"Kl9Ntlwwj":{"layout":["auto","fixed"]}}}',
        framerComponentViewportWidth: "true",
        framerColorSyntax: "true",
        framerAutoSizeImages: "true",
        framerDisplayContentsDiv: "false",
        framerImmutableVariables: "true",
        framerContractVersion: "1",
        framerIntrinsicHeight: "48",
        framerIntrinsicWidth: "127"
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};
//# sourceMappingURL=./yG10ruTg3.map